/*
 * @Description:
 * @Author: kadenwang@tencent.com
 * @Date: 2020-05-19 15:45:28
 * @LastEditors: kadenwang@tencent.com
 * @LastEditTime: 2020-05-19 15:45:29
 */

import Market from './Market';

export interface ISdkInfo {
  sdkVersion: string;
  appVersion: string;
}

const Sdk = {
  GetSdkInfo: (): Promise<ISdkInfo> => Market.__asyncCallApi('Sdk.GetSdkInfo', {}),
};

export default Sdk;
